import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PermissionDeniedMessage } from '../../../core/models/api/errors/permission-denied-error.interface';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-permission-denied-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './permission-denied-modal.component.html',
  styleUrls: ['./permission-denied-modal.component.scss']
})
export class PermissionDeniedModalComponent implements OnInit, OnDestroy {
  permissionData!: PermissionDeniedMessage;
  autoCloseTimer: any = null;
  remainingSeconds = 10;
  countdownInterval: any = null;

  constructor(
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.permissionData = this.dialogConfig.data?.permissionData;
    this.startAutoCloseTimer();
  }

  ngOnDestroy(): void {
    this.clearTimers();
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  onContactAdminClick(): void {
    this.dialogRef.close('contact');
  }

  private startAutoCloseTimer(): void {
    const AUTO_CLOSE_DELAY = 10000;

    this.autoCloseTimer = setTimeout(() => {
      this.dialogRef.close();
    }, AUTO_CLOSE_DELAY);

    this.countdownInterval = setInterval(() => {
      this.remainingSeconds--;
      if (this.remainingSeconds <= 0) {
        this.clearTimers();
      }
    }, 1000);
  }

  private clearTimers(): void {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }
}
